import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ListItem as OriListItem, Tooltip, Button } from 'appkit-react';
// import { Menu, Dropdown } from 'antd';
import { useDispatch } from 'react-redux';
// import '@style/components/archiveCard.scss';
import '../../styles/components/archiveCard.scss';
import { Tag } from '@components';
import alert from '@components/alert';
import { API } from '@service';
import actions from '@flux/action';
import { formatUserLocalDate } from '@utils/widget.js';
import ProjectTag from '@components/projectCard/Tag';
import useHideProjectDetail from '@hooks/useHideProjectDetail';

function ListItem(props) {
  const { data, onClick, userPreference } = props;
  const {
    projectName,
    targetIndustry,
    buyerIndustry,
    buyerName,
    targetName,
    projectId,
    createdAt,
    pinned = false,
    companyInstance,
    instanceName,
  } = data;
  const { shouldShowDetail } = userPreference;

  const dispatch = useDispatch();

  const handleRestore = async (close) => {
    close();
    dispatch(actions.changeLoading(true));
    await API.restoreProject(projectId);
    dispatch(actions.changeLoading(false));
    dispatch(actions.deleteProjectFromArchiveList(projectId));
  };

  // const { value: shouldShowDetail } = useHideProjectDetail();

  const handleClick = (e) => {
    onClick && onClick(data, e);
  };

  const formatStringToEDTTimeStr = (dateStr) => {
    const d = new Date(dateStr);
    if (isNaN(d.valueOf())) {
      return '';
    }
    const result = formatUserLocalDate(dateStr);
    return (
      <>
        Created <p>{result}</p>
      </>
    );
  };

  return (
    <OriListItem className="archive-card-wrapper" onClick={handleClick}>
      {pinned ? <span className="appkiticon icon-pin" /> : <div />}
      <div className="content">
        <div className="owner-wrapper">
          <div className="project-name">{projectName}</div>
          <div className="create-at">{formatStringToEDTTimeStr(createdAt)}</div>
        </div>
        {shouldShowDetail ? (
          <>
            {/*<ProjectTag companyInstance={companyInstance} type={instanceName} />*/}

            <div className="steps-wrapper">
              <div className="subinfo-wrapper">
                <div className="info">
                  <div className="title">client</div>
                  <Tooltip content={buyerName || ''} placement="top-start">
                    <div className="text">{buyerName}</div>
                  </Tooltip>
                  {buyerIndustry && (
                    <Tooltip
                      content={buyerIndustry || ''}
                      placement="top-start"
                    >
                      <Tag className="text">{buyerIndustry}</Tag>
                    </Tooltip>
                  )}
                </div>

                <div className="info">
                  <div className="title">target</div>
                  <Tooltip content={targetName || ''} placement="top-start">
                    <div className="text">{targetName}</div>
                  </Tooltip>
                  {targetIndustry && (
                    <Tooltip
                      content={targetIndustry || ''}
                      placement="top-start"
                    >
                      <Tag className="text">{targetIndustry}</Tag>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : null}
        <div className="setting-wrapper">
          <Button
            className="restore-btn"
            onClick={() => {
              alert.confirm({
                content: 'Do you want to restore this project?',
                okText: 'yes',
                onOk: handleRestore,
              });
            }}
          >
            Restore
          </Button>
        </div>
      </div>
    </OriListItem>
  );
}

ListItem.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = ({ projects }) => ({
  userPreference: projects.userPreference,
});

export default connect(mapStateToProps)(React.memo(ListItem));
